class ColorChange extends HTMLElement {
  connectedCallback() {
    this.onChange = this.onChange.bind(this);

    document.addEventListener("change", this.onChange);


    document.addEventListener('DOMContentLoaded', () => {
      const checkedRadio = this.closest(".km-custom-selects, nwt-neckl-charms ")
        ?.querySelector(
          'fieldset.color-selection-set input[type="radio"]:checked'
        );
  
      
      if (checkedRadio) {
        // this.initTimer = setTimeout(() => {
        //   this.emitColorChange(checkedRadio);
        // }, 2000);
        // this.initTimer = setTimeout(() => {
          this.emitColorChange(checkedRadio);
        // }, 2000);
      }

    });

  }

  disconnectedCallback() {
    document.removeEventListener("change", this.onChange);

    if (this.initTimer) {
      clearTimeout(this.initTimer);
    }
  }

  onChange(e) {
    const radio = e.target.closest(
      'fieldset.color-selection-set input[type="radio"]'
    );

    if (!radio || !radio.checked) return;

    const container = this.closest(".km-custom-selects");

    if (container && !container.contains(radio)) return;

    this.emitColorChange(radio);
  }

  emitColorChange(radio) {
    // console.log('... emit', radio.dataset.color);
    
    this.dispatchEvent(
      new CustomEvent("color-change", {
        detail: {
          value: radio.dataset.color,
          radio,
        },
        bubbles: true,
        composed: true,
      })
    );
  }
}

customElements.define("nwt-color-change", ColorChange);